import { motion } from 'framer-motion'
import { 
  HandRaisedIcon, 
  BellAlertIcon, 
  ShieldCheckIcon 
} from '@heroicons/react/24/outline'

const steps = [
  { icon: HandRaisedIcon, color: 'primary' },
  { icon: BellAlertIcon, color: 'primary' },
  { icon: ShieldCheckIcon, color: 'primary' }
]

export default function HowItWorks({ t }) {
  return (
    <section className="section-padding">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-display font-bold text-neutral-900">
            {t.howItWorks.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {Object.keys(t.howItWorks).filter(key => key.startsWith('step')).map((stepKey, index) => {
            const step = t.howItWorks[stepKey]
            const Icon = steps[index].icon
            
            return (
              <motion.div
                key={stepKey}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative"
              >
                {/* Connector Line - Desktop Only */}
                {index < 2 && (
                  <div className="hidden md:block absolute top-16 left-[60%] w-full h-0.5 bg-gradient-to-r from-primary-300 to-transparent -z-10"></div>
                )}
                
                <div className="card text-center hover:scale-105 transition-transform duration-300">
                  {/* Step Number */}
                  <div className="inline-block bg-primary-100 text-primary-600 font-bold text-lg rounded-full h-10 w-10 flex items-center justify-center mb-6">
                    {index + 1}
                  </div>
                  
                  {/* Icon */}
                  <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-3xl p-6 inline-block mb-6">
                    <Icon className="h-12 w-12 text-white" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-bold text-neutral-900 mb-4 min-h-[3.5rem]">
                    {step.title}
                  </h3>
                  <p className="text-neutral-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            )
          })}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <p className="text-lg text-neutral-600">
            {t.howItWorks.title === '使い方' 
              ? 'シンプル。効果的。安心。' 
              : 'Simple. Effective. Peace of mind.'}
          </p>
        </motion.div>
      </div>
    </section>
  )
}
